module.exports = __webpack_public_path__ + "static/media/frente1.0a784a52.jpg";